<template id="editable-column-content">
  <div>
    <div v-if="isEditing
                  && (scope.row === editing.row)
                  && (scope.column.property === editing.column.property)" class="block">
      <el-date-picker
        type="date"
        format="MMM-dd-yyyy"
        value-format="yyyy-MM-dd"
        v-model="scope.row[property]" @blur="run"
        @keyup.enter="$emit('enter-input')">
      </el-date-picker>
    </div>
    <template  v-else>
      <span v-if="scope.row[property]!=null" style="margin-left: 10px">{{ scope.row[property] | ociTimestamp}}</span>
      <span  v-if="scope.row[property]==null" style="margin-left: 10px">&nbsp;</span>
    </template>
  </div>
</template>
<script>
  import {DatePicker} from 'element-ui';
  export default {
    name: "EditableColumnTypeDate",
    components:{
      [DatePicker.name]: DatePicker,
    },
    props: ['is-editing', 'scope', 'editing', 'on-blur', 'on-enter', 'property'],
    mounted() {
    },
    methods:{
      run(){
        this.$emit('blur-input', {field: this.property, index: this.scope.$index, value: this.scope.row});
        // this.ociLog("run");
        // this.ociLog(this.scope.$index);
        // this.ociLog({field: this.property, index: this.scope.$index, value: this.scope.row[this.property]});
      }
    },
    directives: {
      focus: {
        // directive definition
        inserted: function (el) {
          el.focus()
        }
      }
    }
  }

</script>

<style scoped>

</style>
